'use client'

import { Sidebar, useUI } from 'app/_components/ui'
import { ICartSidebar } from 'types/contentful/cartSidebar'
import { CartSidebarView } from './CartSidebarView/CartSidebarView'
import { Entry } from 'contentful'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import useSharedCart from 'app/(main)/_hooks/useSharedCart'

const SharedCartLoader = () => {
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-white opacity-90 z-[10000000] flex">
      <img
        className="w-40 h-40 m-auto rounded-full justify-center items-center"
        src={'/icon-uploading-new-brand.gif'}
        alt="uploading"
      />
    </div>
  )
}

export default function CartSidebar({
  cartSidebarData,
}: {
  cartSidebarData: ICartSidebar
}) {
  const { displaySidebar, closeSidebar, openSidebar } = useUI()
  const query = useSearchParams()
  const openSidebarOnLoad = query.get('openSidebar') === 'true'
  const cartHash = query.get('cartHash')

  const { loadingSharedCart } = useSharedCart({
    cartHash,
    openCart: openSidebar,
  })

  useEffect(() => {
    if (openSidebarOnLoad && typeof openSidebar === 'function') {
      openSidebar()
    }
  }, [openSidebarOnLoad])

  return (
    <>
      {loadingSharedCart && <SharedCartLoader />}

      <Sidebar open={displaySidebar} onClose={closeSidebar}>
        <CartSidebarView cartSidebarData={cartSidebarData} />
      </Sidebar>
    </>
  )
}
